var swiper = new Swiper(".daily-essentials-swiper", {
  slidesPerView: 4,
  spaceBetween: 20,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
    },
    768: {
      slidesPerView: 4,
    },
  },
});


var swiper = new Swiper(".switch-banner-swiper", {
  slidesPerView: 1,
  effect: "fade",
  loop: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  speed: 1000,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true
  },
  breakpoints: {
    0: { slidesPerView: 1 },
    768: { slidesPerView: 1 }
  },
  // Add these to customize navigation buttons
  on: {
    init: function () {
      // Replace default arrows with Font Awesome icons
      this.navigation.nextEl.innerHTML = '<i class="fas fa-chevron-right"></i>';
      this.navigation.prevEl.innerHTML = '<i class="fas fa-chevron-left"></i>';
    }
  }
});



var customerReviews = $(".customer-reviews-slider");
  customerReviews.owlCarousel({
      items: 4.5,
      margin: 20,
      speed: 1000,
      loop: true,
      nav: true,
      center: true,
      navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right'></i>"],
      dots: false,
      autoplay: true,
      responsive: {
          0: {
              items: 1.2,
              loop: true,
              nav: true,
          },
          600: {
              items: 3,
              nav: true,
          },
          992: {
              items: 4.5,
              nav: true,
          }
      }
  });

var customerSay = $(".customers-say-carousel");
  customerSay.owlCarousel({
      items: 4,
      margin: 20,
      speed: 1000,
      loop: true,
      nav: false,
      dot: true,
      navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right'></i>"],
      dots: false,
      autoplay: false,
      responsive: {
          0: {
              items: 1.2,
              loop: true,
              nav: true,
          },
          600: {
              items: 2,
              nav: true,
          },
          992: {
              items: 4,
              nav: true,
          }
      }
  });


